var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 36,
    viewBox: "0 0 48 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 47.9966,
    height: 36,
    rx: 8,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 46.9966,
    height: 35,
    rx: 7.5,
    stroke: "#040517",
    strokeOpacity: 0.08
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.0004 10.3999C29.3318 10.3999 29.6004 10.6685 29.6004 10.9999V12.3999L30.9996 12.3999C31.331 12.3999 31.5996 12.6685 31.5996 12.9999C31.5996 13.3313 31.331 13.5999 30.9996 13.5999H29.6004V14.9999C29.6004 15.3313 29.3318 15.5999 29.0004 15.5999C28.669 15.5999 28.4004 15.3313 28.4004 14.9999V13.5999H26.9996C26.6682 13.5999 26.3996 13.3313 26.3996 12.9999C26.3996 12.6685 26.6682 12.3999 26.9996 12.3999L28.4004 12.3999V10.9999C28.4004 10.6685 28.669 10.3999 29.0004 10.3999ZM17.6004 14.3749C17.6004 13.9024 17.9444 13.5999 18.2731 13.5999H25.0004C25.3318 13.5999 25.6004 13.3313 25.6004 12.9999C25.6004 12.6685 25.3318 12.3999 25.0004 12.3999H18.2731C17.196 12.3999 16.4004 13.3287 16.4004 14.3749V16.9999V22.6249C16.4004 23.6712 17.196 24.5999 18.2731 24.5999H29.7277C30.8048 24.5999 31.6004 23.6712 31.6004 22.6249L31.6004 16.9999L31.6004 14.9999C31.6004 14.6685 31.3318 14.3999 31.0004 14.3999C30.669 14.3999 30.4004 14.6685 30.4004 14.9999V16.3999H17.6004V14.3749ZM17.6004 17.5999V22.6249C17.6004 23.0974 17.9444 23.3999 18.2731 23.3999H29.7277C30.0564 23.3999 30.4004 23.0974 30.4004 22.6249V17.5999H17.6004Z",
    fill: "#040517"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddCard);
export default __webpack_public_path__ + "static/media/addCard.f22730d55ca35620f9fe65e7507e5e5f.svg";
export { ForwardRef as ReactComponent };